import React, { Fragment, useState, useEffect, useRef } from "react";
import PortalMenu from "../Common/PortalMenu";
import { Row, Col, Card, Table, Badge, Dropdown, Modal } from "react-bootstrap";
import AppPagination from "../Common/AppPagination";
import swal from "sweetalert";
import api, { getFileUrl } from "../../../api";
import UserAvatar from "../Common/UserAvatar";
import Select from "react-select";
import { allCountries } from "country-telephone-data";
import { useSelector } from "react-redux";

import { Link, useNavigate, useLocation } from "react-router-dom";

const API_URL = "/users";
const ROLE_API_URL = "/roles";

const Users = () => {
 const currentUser = useSelector((state) => state.auth?.userDetails || {});
 const isAdmin = String(currentUser?.role?.name || currentUser?.roleName || currentUser?.role || "")
 .toLowerCase()
 .trim() === "admin";
 const { search } = useLocation();
 const params = new URLSearchParams(search);
 const mode = params.get("mode"); // "add-employee" or null
 const navigate = useNavigate();
 const [users, setUsers] = useState([]);
 const [employeeUserIds, setEmployeeUserIds] = useState([]);
 const [showConvertModal, setShowConvertModal] = useState(false);
 const [selectedUser, setSelectedUser] = useState(null);
 const [editCountryCode, setEditCountryCode] = useState(null);

 const countryOptions = allCountries.map((c) => ({
 value: c.iso2.toUpperCase(), // IN, US, GB
 label: `+${c.dialCode} (${c.name})`,
 dialCode: `+${c.dialCode}`,
 }));
 const [countryCode, setCountryCode] = useState(
 countryOptions.find((c) => c.value === "IN"), // default India
 );

 const [employeeForm, setEmployeeForm] = useState({
 level: "Junior",
 skills: [],
 dailyCapacityHours: 8,
 });

 const [roles, setRoles] = useState([]);

 const [postModal, setPostModal] = useState(false);
 const [editModal, setEditModal] = useState(false);

 const [newUser, setNewUser] = useState({
 name: "",
 mobile: "",
 email: "",
 password: "",
 role: "",
 image: "",
 });

 const [editUser, setEditUser] = useState(null);
 const [file, setFile] = useState(null);
 const [editFile, setEditFile] = useState(null);

 const [pagination, setPagination] = useState({
 currentPage: 1,
 totalPages: 1,
 totalCount: 0,
 limit: 10,
 });
 const [loading, setLoading] = useState(false);
 const [searchTerm, setSearchTerm] = useState("");
 const isFirstMount = useRef(true);

 // Fetch Users
 const fetchUsers = async (page = pagination.currentPage, search = searchTerm) => {
 try {
 setLoading(true);
 const queryParams = new URLSearchParams();
 queryParams.append("page", page);
 queryParams.append("limit", pagination.limit);
 const s = typeof search === "string" ? search.trim() : (searchTerm || "").trim();
 if (s) {
 queryParams.append("search", s);
 }
 const res = await api.get(`${API_URL}?${queryParams.toString()}`);
 if (res.data.success) {
 setUsers(res.data.data || []);
 if (res.data.pagination) {
 setPagination(prev => ({
 ...prev,
 ...res.data.pagination,
 currentPage: Number(res.data.pagination.currentPage || page)
 }));
 }
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 fetchRoles();
 fetchEmployees();
 }, []);

 useEffect(() => {
 fetchUsers(pagination.currentPage, searchTerm);
 }, [pagination.currentPage]);

 useEffect(() => {
 if (isFirstMount.current) {
 isFirstMount.current = false;
 return;
 }
 const timer = setTimeout(() => {
 if (pagination.currentPage === 1) {
 fetchUsers(1, searchTerm);
 } else {
 setPagination(prev => ({ ...prev, currentPage: 1 }));
 }
 }, 350);
 return () => clearTimeout(timer);
 }, [searchTerm]);

 const handlePageChange = (page) => {
 if (page === pagination.currentPage) return;
 setPagination(prev => ({ ...prev, currentPage: page }));
 };
 const handleRemoveEmployee = async (userId) => {
 const confirm = await swal({
 title: "Remove Employee?",
 text: "This will remove employee record but user will remain.",
 icon: "warning",
 buttons: true,
 dangerMode: true,
 });

 if (!confirm) return;

 try {
 const res = await api.delete(`/employees/by-user/${userId}`);
 if (res.data.success) {
 swal("Removed!", "Employee removed successfully!", "success");
 fetchEmployees();
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
 };

 const fetchEmployees = async () => {
 try {
 const res = await api.get("/employees");
 if (res.data.success) {
 setEmployeeUserIds(res.data.employees.map((e) => e.userId));
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
 };
 const isEmployee = (userId) => employeeUserIds.includes(userId);
 const handleConvertToEmployee = async (userId) => {
 const confirm = await swal({
 title: "Convert to Employee?",
 text: "This user will be added as an employee.",
 icon: "warning",
 buttons: true,
 });

 if (!confirm) return;

 try {
 const res = await api.post("/employees", {
 userId,
 skills: [],
 level: "Junior",
 dailyCapacityHours: 8,
 });

 if (res.data.success) {
 swal("Success", "User converted to Employee!", "success");
 fetchEmployees();
 // optionally: navigate("/employee-crm");
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
 };

 // Fetch User Roles
 const fetchRoles = async () => {
 try {
 const res = await api.get(`${ROLE_API_URL}?limit=100`);
 if (res.data.success) setRoles(res.data.data);
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
 };

 // Add User Input Change
 const handleAddChange = (e) => {
 const { name, value } = e.target;
 setNewUser((prev) => ({ ...prev, [name]: value }));
 };

 // Edit User Input Change
 const handleEditChange = (e) => {
 const { name, value } = e.target;
 setEditUser((prev) => ({ ...prev, [name]: value }));
 };
const getUserProjects = (user) => {
 // Manager → show projects they manage
 if (user.role?.name === "Manager") {
 return user.managerProjects || [];
 }

 // Engineers → show assigned work orders
 return user.assignedWorkOrders || [];
};

 const fileHandler = (e) => setFile(e.target.files[0]);
 const editFileHandler = (e) => setEditFile(e.target.files[0]);
// ==========================
// MOBILE VALIDATION
// ==========================
const validateMobile = (mobile) => {
 const cleaned = mobile.replace(/\D/g, ""); // remove non-numbers

 // Example: allow 7–12 digits depending on country
 if (cleaned.length < 7 || cleaned.length > 12) {
 return false;
 }

 return true;
};
 // ADD USER
 const handleAddSubmit = async (e) => {
 e.preventDefault();

 if (
 !newUser.name ||
 !newUser.mobile ||
 !newUser.email ||
 !newUser.password
 ) {
 swal("Oops", "Please fill all required fields", "error");
 return;
 }
if (!validateMobile(newUser.mobile)) {
 swal("Invalid Mobile", "Please enter a valid mobile number", "error");
 return;
}
 try {
 const formData = new FormData();

 Object.keys(newUser).forEach((key) => {
 if (key === "mobile") {
 formData.append(
 "mobile",
 `${countryCode.dialCode}${newUser.mobile}`
 );
 } else {
 formData.append(key, newUser[key]);
 }
});


 if (file) formData.append("image", file);

 const res = await api.post(API_URL, formData, {
 headers: { "Content-Type": "multipart/form-data" },
 });

 if (res.data.success) {
 swal("Success", "User added successfully!", "success");
 setPostModal(false);
 setFile(null);
 setNewUser({
 name: "",
 mobile: "",
 email: "",
 password: "",
 role: "",
 image: "",
 });
 fetchUsers();
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
 };
 const renderAssignedData = (user) => {
 const workOrders = user.assignedWorkOrders || [];
 const projects = user.assignedProjects || [];
 const managed = user.managerProjects || [];

 // Combine all unique work orders
 const allWOs = [...workOrders, ...managed];
 const uniqueWOs = Array.from(new Map(allWOs.map((item) => [item._id, item])).values());

 if (!uniqueWOs.length && !projects.length) {
 return <span className="text-muted">No Assignments</span>;
 }

 const renderItem = (item, isProject = false) => {
 if (isProject) {
 return (
 <div key={item._id} className="mb-1">
 <Badge bg="info" className="me-1">Project</Badge>
 {item.projectName || item.projectCode}
 </div>
 );
 }
 return (
 <div key={item._id} className="mb-1">
 <Badge bg="primary" className="me-1">WO</Badge>
 <strong>{item.woNo}{item.label ? ` (${item.label})` : ""}</strong>
 </div>
 );
 };

 const allItems = [
 ...projects.map(p => ({ ...p, _isProject: true })),
 ...uniqueWOs.map(wo => ({ ...wo, _isProject: false }))
 ];

 if (allItems.length <= 2) {
 return (
 <div style={{ fontSize: "12px" }}>
 {allItems.map(item => renderItem(item, item._isProject))}
 </div>
 );
 }

 const [first, second, ...rest] = allItems;

 return (
 <Dropdown>
 <Dropdown.Toggle variant="" size="sm" className="border px-2 py-1" style={{ fontSize: "12px" }}>
 {first._isProject ? "Project: " : "WO: "}
 {first._isProject ? (first.projectName || first.projectCode) : `${first.woNo}${first.label ? ` (${first.label})` : ""}`}
 <span className="ms-1 text-primary">+{allItems.length - 1} more</span>
 </Dropdown.Toggle>

 <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto", minWidth: "200px" }}>
 <div className="p-2">
 {allItems.map(item => renderItem(item, item._isProject))}
 </div>
 </Dropdown.Menu>
 </Dropdown>
 );
 };

 // EDIT USER
 const handleEditSubmit = async (e) => {
 e.preventDefault();

 if (!editUser || !editUser.name || !editUser.mobile || !editUser.email) {
 swal("Oops", "Please fill all required fields", "error");
 return;
 }
 if (!validateMobile(editUser.mobile)) {
 swal("Invalid Mobile", "Please enter a valid mobile number", "error");
 return;
}

 try {
 const formData = new FormData();

 Object.keys(editUser).forEach((key) => {
 const value = editUser[key];

 // skip invalid values
 if (
 value === null ||
 value === "" ||
 value === "null" ||
 value === undefined
 ) {
 return;
 }

 // [OK] MOBILE HANDLING (SAFE)
 if (key === "mobile") {
 let cleanNumber = String(editUser.mobile).replace(/[\s-]/g, "");

 // fallback country code (India default)
 const dialCode =
 editCountryCode?.dialCode ||
 countryOptions.find((c) => c.value === "IN")?.dialCode ||
 "";

 // prevent double dial code
 if (dialCode && cleanNumber.startsWith(dialCode)) {
 cleanNumber = cleanNumber.replace(dialCode, "");
 }

 formData.append("mobile", `${dialCode}${cleanNumber}`);
 } else {
 formData.append(key, value);
 }
 });

 if (editFile) {
 formData.append("image", editFile);
 }

 const res = await api.patch(`${API_URL}/${editUser._id}`, formData, {
 headers: { "Content-Type": "multipart/form-data" },
 });

 if (res.data.success) {
 swal("Success", "User updated!", "success");
 setEditModal(false);
 setEditFile(null);
 fetchUsers();
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
};

 // DELETE USER
 const handleDelete = async (id) => {
 const confirm = await swal({
 title: "Are you sure?",
 text: "This user will be permanently deleted!",
 icon: "warning",
 buttons: ["Cancel", "Delete"],
 dangerMode: true,
 });

 if (!confirm) return;

 try {
 const res = await api.delete(`${API_URL}/${id}`);
 if (res.data.success) {
 swal("Deleted!", "User deleted successfully!", "success");
 fetchUsers();
 }
 } catch (err) {
 swal("Error", err.response?.data?.message || err.message, "error");
 }
 };

 const svgMenu = (
 <svg width="20" height="20" viewBox="0 0 24 24">
 <circle fill="#000" cx="5" cy="12" r="2" />
 <circle fill="#000" cx="12" cy="12" r="2" />
 <circle fill="#000" cx="19" cy="12" r="2" />
 </svg>
 );

 return (
 <Fragment>
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-3 py-3">
 <Card.Title className="mb-0">User List</Card.Title>
 <div className="d-flex align-items-center flex-wrap gap-2">
 <div className="position-relative" style={{ width: "280px" }}>
 <i
 className="fas fa-search text-muted position-absolute"
 style={{
 left: "14px",
 top: "50%",
 transform: "translateY(-50%)",
 fontSize: "14px",
 pointerEvents: "none",
 }}
 ></i>
 <input
 type="text"
 className="form-control"
 placeholder="Search by name, email, mobile..."
 value={searchTerm}
 onChange={(e) => setSearchTerm(e.target.value)}
 style={{
 height: "40px",
 paddingLeft: "38px",
 paddingRight: searchTerm ? "34px" : "12px",
 fontSize: "0.875rem",
 borderRadius: "8px",
 border: "1px solid #ced4da",
 backgroundColor: "#fff",
 boxShadow: "none",
 }}
 />
 {searchTerm && (
 <button
 type="button"
 className="btn btn-link position-absolute p-0 text-muted"
 style={{
 right: "10px",
 top: "50%",
 transform: "translateY(-50%)",
 width: "20px",
 height: "20px",
 lineHeight: "1",
 textDecoration: "none",
 }}
 onClick={() => setSearchTerm("")}
 title="Clear search"
 >
 <i className="fas fa-times" style={{ fontSize: "12px" }}></i>
 </button>
 )}
 </div>
 {isAdmin && (
 <Link
 className="btn btn-outline-primary d-inline-flex align-items-center px-3"
 to="/reporting-tree"
 style={{ height: "40px", borderRadius: "8px", fontSize: "0.875rem" }}
 >
 Reporting Tree
 </Link>
 )}
 {mode !== "add-employee" && (
 <button
 className="btn btn-primary d-inline-flex align-items-center px-3"
 onClick={() => setPostModal(true)}
 style={{ height: "40px", borderRadius: "8px", fontSize: "0.875rem" }}
 >
 + Add User
 </button>
 )}
 </div>
 </Card.Header>

 <Card.Body>
 <div className="table-responsive" style={{ overflow: "visible" }}>
 <Table hover className="align-middle">
 <thead>
 <tr>
 <th>#</th>
 <th>Image</th>
 <th>Name</th>
 <th>Email</th>
 <th>Mobile</th>
 <th>Role</th>
 <th>Assigned Projects & WOs</th>
 <th></th>
 </tr>
 </thead>

 <tbody>
 {loading ? (
 <tr>
 <td colSpan={8} className="text-center py-4">
 <div className="spinner-border text-primary spinner-border-sm me-2" role="status"></div>
 <span className="text-muted">Loading users...</span>
 </td>
 </tr>
 ) : users.length === 0 ? (
 <tr>
 <td colSpan={8} className="text-center py-4 text-muted">
 No users found.
 </td>
 </tr>
 ) : (
 users.map((user, i) => (
 <tr key={user._id}>
 <td>
 <strong>{(pagination.currentPage - 1) * (pagination.limit || 10) + i + 1}</strong>
 </td>

 <td>
 <UserAvatar
 src={user.image ? getFileUrl(user.image) : null}
 size={45}
 alt={user.name}
 />
 </td>

 <td>{user.name}</td>
 <td>{user.email}</td>
 <td>{user.mobile}</td>

 <td>
 <Badge bg="primary">
 {user.role?.name || "No Role"}
 </Badge>
 </td>

 {/* SHOW WORK ORDERS & PROJECTS ASSIGNED */}
 <td>{renderAssignedData(user)}</td>

 <td>
 {mode === "add-employee" ? (
 isEmployee(user._id) ? (
 <div className="d-flex align-items-center gap-2">
 <Badge bg="success" style={{ fontSize: "12px" }}>
 Employee
 </Badge>

 <button
 className="btn btn-link p-0 text-primary"
 style={{ fontSize: "12px" }}
 onClick={() =>
 navigate(`/employee-crm?user=${user._id}`)
 }
 >
 View
 </button>

 <button
 className="btn btn-link p-0 text-danger"
 style={{ fontSize: "12px" }}
 onClick={() => handleRemoveEmployee(user._id)}
 >
 Remove
 </button>
 </div>
 ) : (
 <button
 className="btn btn-sm btn-outline-dark"
 onClick={() => {
 setSelectedUser(user);
 setShowConvertModal(true);
 }}
 >
 + Add as Employee
 </button>
 )
 ) : (
 <Dropdown>
 <Dropdown.Toggle
 as="div"
 className="btn-link p-0 i-false"
 style={{ cursor: "pointer" }}
 >
 {svgMenu}
 </Dropdown.Toggle>
 <Dropdown.Menu align="end" as={PortalMenu}>
 <Dropdown.Item
 onClick={() => {
 const mobile = user.mobile || "";

 // Find matching country code
 const matchedCountry =
 countryOptions.find((c) =>
 mobile.startsWith(c.dialCode)
 ) || countryOptions.find((c) => c.value === "IN");

 const numberOnly = matchedCountry
 ? mobile.replace(matchedCountry.dialCode, "")
 : mobile;

 setEditCountryCode(matchedCountry);

 setEditUser({
 ...user,
 mobile: numberOnly,
 role: user.role?._id || "",
 });

 setEditModal(true);
}}

 >
 Edit
 </Dropdown.Item>

 <Dropdown.Item
 className="text-danger"
 onClick={() => handleDelete(user._id)}
 >
 Delete
 </Dropdown.Item>
 </Dropdown.Menu>
 </Dropdown>
 )}
 </td>
 </tr>
 ))
 )}
 </tbody>
 </Table>
 </div>
 <AppPagination
 currentPage={pagination.currentPage}
 totalPages={pagination.totalPages}
 totalCount={pagination.totalCount}
 itemsLength={users.length}
 limit={pagination.limit}
 onPageChange={handlePageChange}
 />
 </Card.Body>
 </Card>
 </Col>

 {/* ADD USER MODAL */}
 <Modal show={postModal} onHide={() => setPostModal(false)} centered>
 <form onSubmit={handleAddSubmit}>
 <div className="modal-header">
 <h4>Add User</h4>
 <button
 type="button"
 className="btn-close"
 onClick={() => setPostModal(false)}
 ></button>
 </div>

 <div className="modal-body">
 <div className="form-group mb-3">
 <label>Name</label>
 <input
 type="text"
 name="name"
 value={newUser.name}
 onChange={handleAddChange}
 className="form-control"
 required
 />
 </div>

 <div className="form-group mb-3">
 <label>Email</label>
 <input
 type="email"
 name="email"
 value={newUser.email}
 onChange={handleAddChange}
 className="form-control"
 required
 />
 </div>
<div className="form-group mb-3">
 <label>Mobile</label>

 <div className="d-flex gap-2 align-items-center">
 <div style={{ width: "160px" }}>
 <select
 className="form-select"
 value={countryCode?.value || "IN"}
 onChange={(e) => {
 const selected = countryOptions.find(c => c.value === e.target.value);
 setCountryCode(selected);
 }}
 >
 {countryOptions.map((c) => (
 <option key={c.value} value={c.value}>
 {c.dialCode} ({c.value})
 </option>
 ))}
 </select>
 </div>

 <input
 type="text"
 name="mobile"
 value={newUser.mobile}
 onChange={(e) => {
 const value = e.target.value.replace(/\D/g, "");
 setNewUser((prev) => ({ ...prev, mobile: value }));
 }}
 className="form-control"
 placeholder="Mobile number"
 maxLength={10}
 required
/>
 </div>
</div>


 <div className="form-group mb-3">
 <label>Password</label>
 <input
 type="password"
 name="password"
 value={newUser.password}
 onChange={handleAddChange}
 className="form-control"
 required
 />
 </div>

 <div className="form-group mb-3">
 <label>Role</label>
 <select
 name="role"
 value={newUser.role}
 onChange={handleAddChange}
 className="form-select"
 >
 <option value="">Select Role</option>
 {roles
 .filter(role => role.name && role.name.toLowerCase() !== "super admin" && role.name.toLowerCase() !== "superadmin")
 .map((role) => (
 <option key={role._id} value={role._id}>
 {role.name}
 </option>
 ))}
 </select>
 </div>

 <div className="form-group mb-3">
 <label>Profile Image</label>
 <input
 type="file"
 accept="image/*"
 onChange={fileHandler}
 className="form-control"
 />
 {file && (
 <img
 src={URL.createObjectURL(file)}
 width="80"
 height="80"
 className="rounded-circle mt-2"
 alt="Preview"
 style={{ objectFit: "cover" }}
 />
 )}
 </div>
 </div>

 <div className="modal-footer">
 <button className="btn btn-primary" type="submit">
 Add
 </button>
 <button
 className="btn btn-danger"
 type="button"
 onClick={() => setPostModal(false)}
 >
 Cancel
 </button>
 </div>
 </form>
 </Modal>

 {/* EDIT USER MODAL */}
 <Modal show={editModal} onHide={() => setEditModal(false)} centered>
 <form onSubmit={handleEditSubmit}>
 <div className="modal-header">
 <h4>Edit User</h4>
 <button
 type="button"
 className="btn-close"
 onClick={() => setEditModal(false)}
 ></button>
 </div>

 <div className="modal-body">
 {editUser && (
 <>
 <div className="form-group mb-3">
 <label>Name</label>
 <input
 type="text"
 name="name"
 value={editUser.name}
 onChange={handleEditChange}
 className="form-control"
 required
 />
 </div>

 <div className="form-group mb-3">
 <label>Email</label>
 <input
 type="email"
 name="email"
 value={editUser.email}
 onChange={handleEditChange}
 className="form-control"
 required
 />
 </div>

 <div className="form-group mb-3">
 <label>Mobile</label>

 <div className="d-flex gap-2 align-items-center">
 <div style={{ width: "160px" }}>
 <select
 className="form-select"
 value={editCountryCode?.value || "IN"}
 onChange={(e) => {
 const selected = countryOptions.find(c => c.value === e.target.value);
 setEditCountryCode(selected);
 }}
 >
 {countryOptions.map((c) => (
 <option key={c.value} value={c.value}>
 {c.dialCode} ({c.value})
 </option>
 ))}
 </select>
 </div>

 <input
 type="text"
 name="mobile"
 value={editUser.mobile}
 onChange={(e) => {
 const value = e.target.value.replace(/\D/g, "");
 setEditUser((prev) => ({ ...prev, mobile: value }));
 }}
 className="form-control"
 placeholder="Mobile number"
 maxLength={10}
 required
/>
 </div>
</div>

 <div className="form-group mb-3">
 <label>Role</label>
 <select
 name="role"
 value={editUser.role}
 onChange={handleEditChange}
 className="form-select"
 >
 <option value="">Select Role</option>
 {roles
 .filter(role => role.name && role.name.toLowerCase() !== "super admin" && role.name.toLowerCase() !== "superadmin")
 .map((role) => (
 <option key={role._id} value={role._id}>
 {role.name}
 </option>
 ))}
 </select>
 </div>

 <div className="form-group mb-3">
 <label>Profile Image</label>
 <input
 type="file"
 accept="image/*"
 onChange={editFileHandler}
 className="form-control"
 />
 <UserAvatar
 src={
 editFile
 ? URL.createObjectURL(editFile)
 : (editUser.image ? getFileUrl(editUser.image) : null)
 }
 size={80}
 alt="Preview"
 style={{ marginTop: "8px" }}
 />
 </div>
 </>
 )}
 </div>

 <div className="modal-footer">
 <button className="btn btn-primary" type="submit">
 Save
 </button>
 <button
 className="btn btn-danger"
 type="button"
 onClick={() => setEditModal(false)}
 >
 Cancel
 </button>
 </div>
 </form>
 </Modal>
 <Modal
 show={showConvertModal}
 onHide={() => setShowConvertModal(false)}
 centered
 >
 <form
 onSubmit={async (e) => {
 e.preventDefault();
 try {
 const res = await api.post("/employees", {
 userId: selectedUser._id,
 ...employeeForm,
 });
 if (res.data.success) {
 swal("Success", "Employee Created!", "success");
 setShowConvertModal(false);
 fetchEmployees();
 }
 } catch (err) {
 swal(
 "Error",
 err.response?.data?.message || err.message,
 "error",
 );
 }
 }}
 >
 <div className="modal-header">
 <h4>Create Employee</h4>
 <button
 type="button"
 className="btn-close"
 onClick={() => setShowConvertModal(false)}
 ></button>
 </div>

 <div className="modal-body">
 <div className="mb-3">
 <label>Level</label>
 <select
 className="form-select"
 value={employeeForm.level}
 onChange={(e) =>
 setEmployeeForm((prev) => ({
 ...prev,
 level: e.target.value,
 }))
 }
 >
 <option>Junior</option>
 <option>Mid</option>
 <option>Senior</option>
 </select>
 </div>

 <div className="mb-3">
 <label>Daily Capacity (hours)</label>
 <input
 type="number"
 className="form-control"
 min="1"
 value={employeeForm.dailyCapacityHours}
 onChange={(e) =>
 setEmployeeForm((prev) => ({
 ...prev,
 dailyCapacityHours: e.target.value,
 }))
 }
 />
 </div>

 <div className="mb-3">
 <label>Skills (comma separated)</label>
 <input
 type="text"
 className="form-control"
 placeholder="React, Node, AutoCAD"
 onChange={(e) =>
 setEmployeeForm((prev) => ({
 ...prev,
 skills: e.target.value.split(",").map((s) => s.trim()),
 }))
 }
 />
 </div>
 </div>

 <div className="modal-footer">
 <button type="submit" className="btn btn-primary">
 Save
 </button>
 <button
 type="button"
 className="btn btn-danger"
 onClick={() => setShowConvertModal(false)}
 >
 Cancel
 </button>
 </div>
 </form>
 </Modal>
 </Row>
 </Fragment>
 );
};

export default Users;
